export default {
    icons: {
        iconfont: "mdiSvg",
    },
    theme: {
        disable: true,
    },
}
